import { render, staticRenderFns } from "./oauth-callback.vue?vue&type=template&id=06496934&"
import script from "./oauth-callback.vue?vue&type=script&lang=js&"
export * from "./oauth-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports